import React from 'react';
import '../../assets/css/title.css';

class Title extends React.Component {
    render() {
        return(
            <section className="main bg-white large-mw-none" role="region">
                       <div className="row">
                          <div>
                                <h1 className="h2 bbuheader colorBlack margin-bottom-xlarge">{this.props.Header}</h1>
                                <div className={(this.props.Content !== "") ?  "text-black padding-bottom-small" :  "text-black padding-bottom-small hide"} dangerouslySetInnerHTML={{ __html: this.props.Content}}>
                                </div>
                             </div>
                         </div>
             </section>
        )
    }
}

export default Title


// WEBPACK FOOTER //
// ./src/components/modules/Title.js